import View from 'ol/View';
import Grid from 'ol-grid';

import Map from 'ol/Map';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { fromLonLat } from 'ol/proj';
import { Feature } from 'ol';
import { Style, Icon, Stroke, Fill, RegularShape } from 'ol/style';
import { Circle } from 'ol/geom';
import { KML } from 'ol/format';
import Point from 'ol/geom/Point';

export function setupMap(state) {

    let snapCoords = [];

    let maxGpsHistory = 10;
    let gpsHistory = Array(maxGpsHistory);
    let gpsHistoryIndex = 0;

    const view = new View({
        center: [0, 0],
        zoom: 20,
    });

    const stroke = new Stroke({ color: 'gray', width: 2 });
    const fill = new Fill({ color: 'black' });

    const grid = new Grid({
        style: new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 4,
                radius: 14,
                radius2: 0,
                angle: Math.PI / 4
            }),
        })
    });

    state.onLocation(loc => {
        if (state.track) view.setCenter(loc);
    })

    // grid follow state
    state.onA(value => grid.setOriginPoint(value));
    state.onB(value => grid.setRotationControlPoint(value));
    state.onTreeGap(value => grid.setXGridSize(value));
    state.onRowGap(value => grid.setYGridSize(value));

    const markerA = new Feature({ geometry: new Point([0, 0]) });

    // Style for the marker
    markerA.setStyle(new Style({
        image: new Icon({
            anchor: [0.5, 44],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: 'images/A.png'  // Path to your marker image
        })
    }));

    // feature follow state
    state.onA(value => markerA.getGeometry().setCoordinates(value));

    const markerB = new Feature({
        geometry: new Point([0, 0])
    });
    markerB.setStyle(new Style({
        image: new Icon({
            anchor: [0.5, 44],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: 'images/B.png'  // Path to your marker image
        })
    }))

    state.onB(value => markerB.getGeometry().setCoordinates(value));

    const gpsMarker = new Feature({
        geometry: new Point(fromLonLat([21.62730157317441, 47.504920400338]))
    });

    state.onGps((value, oldValue) => {
        if (state.track) view.setCenter(value); //.flatCoordinates
        gpsMarker.getGeometry().setCoordinates(value);
        accuracy.setCenter(state.gps);
        treeC.setCenter(state.gps);
        if (oldValue) {
            let dxy = [value[0] - oldValue[0], value[1] - oldValue[1]];
            let d = dxy[0] ** 2 + dxy[1] ** 2;
            if (d > 0.05 * 0.05 || true) { // we moved more than 5cm, write history
                gpsHistory[gpsHistoryIndex] = value;
                oldValue = gpsHistory[(gpsHistoryIndex + maxGpsHistory - 3) % maxGpsHistory];
                gpsHistoryIndex = (gpsHistoryIndex + 1) % maxGpsHistory;
                if (oldValue) {
                    let heading = Math.atan2(value[0] - oldValue[0], value[1] - oldValue[1]);
                    dirMarkerIcon.setRotation(heading);
                }
            }
        }
    });

    // Style for the marker
    const gpsMarkerIcon = new Icon({
        anchor: [0.5, 0.5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        src: 'images/bull.png'  // Path to your marker image
    })

    gpsMarker.setStyle(new Style({
        image: gpsMarkerIcon
    }));

    const dirMarker = new Feature({
        geometry: gpsMarker.getGeometry(),
    });

    // Define the style for the marker, including the directional icon
    const dirMarkerIcon = new Icon({
        anchor: [0.5, 1.2], // Center the icon
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        src: 'images/dir.png',
        rotation: 0, // Rotate the icon based on GPS heading
    });

    const dirMarkerStyle = new Style({
        image: dirMarkerIcon,
    });

    // Apply the style to the marker
    dirMarker.setStyle(dirMarkerStyle);


    // Style for the marker
    const centerMarker = new Feature({
        geometry: new Point([0, 0])
    });
    state.onCenterAt(value => {
        centerMarker.getGeometry().setCoordinates(value);
    });

    centerMarker.setStyle(new Style({
        image: new Icon({
            anchor: [0.5, 0.5],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: 'images/center.png'  // Path to your marker image
        })
    }));

    // Accuracy circle
    var accuracy = new Circle([0, 0], 5);
    var accuracyCircle = new Feature(accuracy);
    accuracyCircle.setStyle(
        new Style({
            radius: 5,
            fill: null,
            stroke: new Stroke({
                color: 'black',
                width: 1
            })
        })
    );

    // tree circle
    var treeC = new Circle([0, 0], 0.15);
    var treeCircle = new Feature(treeC);
    treeCircle.setStyle(
        new Style({
            radius: 0.15,
            fill: null,
            stroke: new Stroke({
                color: 'red',
                width: 1
            })
        })
    );


    state.onFix(fixOn => {
        // if (!view) return;
        //let gpsCoord = new Point(state.gps).transform(view.getProjection(), 'EPSG:4326').getCoordinates();

        let gps = state.gps;
        if(!gps) return;
        let offset;
        if (fixOn) {
            //let aCoord = state.centerAt.clone().transform(view.getProjection(), 'EPSG:4326').getCoordinates();
            //state.fixOffset = [aCoord[0] - gpsCoord[0], aCoord[1] - gpsCoord[1]];
            //latUI.style.backgroundColor = lonUI.style.backgroundColor = '#FFFFCC';
            let ctr = state.centerAt
            state.fixOffset = [ctr[0] - gps[0], ctr[1] - gps[1]];
            offset = state.fixOffset;
        } else {
            offset = state.fixOffset;
            offset[0] = -offset[0];
            offset[1] = -offset[1];
            state.fixOffset = [0, 0];
            //latUI.style.backgroundColor = lonUI.style.backgroundColor = '#FFFFFF';
        }
        let nugps = [gps[0] + offset[0], gps[1] + offset[1]];
        state.gps = nugps;

        // state._gpsAt = new Point(fromLonLat([gpsCoord[0] + state.fixOffset[0], gpsCoord[1] + state.fixOffset[1]]));
    })

    state.onAccuracy((value, oldValue) => {
        // if (oldValue && value > 0.3 && oldValue < 0.3) return; //skip a beat when going from exact to non exact
        accuracy.setRadius(value);
        gpsMarkerIcon.setOpacity(value < 0.1 ? 1.0 : 0.1);
        dirMarkerIcon.setOpacity(value < 0.1 ? 1.0 : 0.1);
    });

    // Add feature to a vector source
    const vectorSource = new VectorSource({
        features: [markerA, markerB, gpsMarker, dirMarker, centerMarker, accuracyCircle, treeCircle]
    });

    // Create a vector layer and add it to the map
    const vectorLayer = new VectorLayer({
        source: vectorSource
    });

    const map = new Map({
        target: 'map',
        layers: [
            new TileLayer({
                source: new OSM()
            })
        ],
        view: view,
    });

    map.addInteraction(grid);
    map.addLayer(vectorLayer);

    map.on('moveend', function (e) {
        // if (!state.gps) state._gpsAt = new Point(view.getCenter());
        let center = view.getCenter();
        // go find nearest kml point
        if (!state.track) {
            let best = center;
            let bestDist = 2 * 2;
            snapCoords.forEach(coord => {
                let d = (coord[0] - center[0]) ** 2 + (coord[1] - center[1]) ** 2;
                if (d < bestDist) {
                    best = [coord[0], coord[1]];
                    bestDist = d;
                }
            })
            state.centerAt = best;
        } else state.centerAt = center;
    });

    // Create a vector source that parses the KML
    const kmlSource = new VectorSource({
        format: new KML()
        //loader: function(extent, resolution, projection, success, failure) {
        //}
    });

    const kmlLayer = new VectorLayer({
        source: kmlSource
    });

    function loadFeatures(source, url) {
        fetch(url)
            .then(response => response.text())
            .then(kmlText => {
                const proxiedKmlText = kmlText //https://reformhaz-epres.dnsalias.net/gps/
                    .replaceAll('<href>https://www.gstatic.com/mapspro/images/stock/503-wht-blank_maps.png</href>', '<href>images/pin.png</href>')
                    .replaceAll('https://www.gstatic.com', 'images')
                    .replaceAll('<hotSpot x="32" xunits="pixels" y="64" yunits="insetPixels"/>', '<hotSpot x="16" xunits="pixels" y="32" yunits="insetPixels"/>');
                const format = new KML();
                const features = format.readFeatures(proxiedKmlText, { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' });
                source.addFeatures(features);
                features.forEach(feature => {
                    snapCoords.push(feature.getGeometry().flatCoordinates);
                })
            })
            .catch(error => console.error('Error loading or processing KML:', error));
    }

    state.onKml(value => {
        kmlSource.clear();
        snapCoords = [];
        if (value !== "") loadFeatures(kmlSource, value);
    });

    map.addLayer(kmlLayer);

}